

































import Vue from 'vue';
import EntitiesTable from '@/common/components/entities/EntitiesTable.vue';
import { Feature } from '@/features.types';
import { mapGetters } from 'vuex';
import PaidFeatureNotEnabled from '@/common/components/PaidFeatureNotEnabled.vue';
import { RateGroupName } from '@/iso/views/merchants/components/sellRates.types';

export default Vue.extend({
  data() {
    return {
      Feature,
      meta: {} as any,
      config: {
        pageTitle: 'Shopping Carts',
        routerBase: 'merchant.shopping-carts',
        apiPath: 'shopping-carts',
        header: 'Shopping Carts',
        reportFileName: 'shopping_carts_report',
        headers: [
          {
            text: 'Store Name',
            value: 'storeName',
            sortable: false,
            class: 'entity-table-header subtitle-2 font-weight-black black--text',
          },
          {
            text: 'Domain',
            value: 'domain',
            sortable: false,
            class: 'entity-table-header subtitle-2 font-weight-black black--text',
          },
          {
            text: 'Monthly Fee',
            value: 'monthlyFee',
            sortable: false,
            class: 'entity-table-header subtitle-2 font-weight-black black--text',
            align: 'center',
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
            align: 'center',
            class: 'entity-table-header subtitle-2 font-weight-black black--text',
          },
        ],
        filters: [],
      },
    };
  },
  computed: {
    ...mapGetters(['isShoppingCartEnabled']),
    getFeatureName() {
      return RateGroupName.SHOPPING_CART;
    },
  },
  components: {
    EntitiesTable,
    PaidFeatureNotEnabled,
  },
});

